// 处理用户api
import request from '@/utils/request.js'
import qs from 'qs'

// 首页未处理内容数量展示
export const untreatedNums = () => {
  return request({
    method: 'get',
    url: '/zzzx/numuserorder',
    data: qs.stringify()
  })
}

// 登录
export const login = ({ username, password }) => {
  return request({
    method: 'post',
    url: '/zzzx/adminlogin',
    data: qs.stringify({
      username,
      password
    })
  })
}

// 个人资料
export const adminInfo = () => {
  return request({
    method: 'get',
    url: '/zzzx/admininfo'
  })
}

// 退出登录
export const loginOut = () => {
  return request({
    method: 'get',
    url: '/zzzx/loginout'
  })
}

// 修改密码
export const modifyPass = ({ oldpassword, password, passwords }) => {
  return request({
    method: 'post',
    url: '/zzzx/modifypass',
    data: qs.stringify({
      oldpassword,
      password,
      passwords
    })
  })
}
// 更新用户头像
// photo file 否 头像
export const updateUserPhoto = (name, file) => {
  const formData = new FormData()
  formData.append(name, file)
  return request({
    method: 'post',
    url: '/zzzx/uploaduserimages',
    data: formData,
  })
}
/**
 * 修改个人资料
 * axios 会把无效数据进行过滤，null、undefined 等数据
 */
export const updateUserProfile = ({
  phone,
  tel,
  image,
  erweima
}) => {
  return request({
    method: 'post',
    url: '/zzzx/admininfo',
    data: qs.stringify({
      phone,
      tel,
      image,
      erweima
    })
  })
}
